import { render, staticRenderFns } from "./TheorySignature.vue?vue&type=template&id=2ae2d4b2&"
import script from "./TheorySignature.vue?vue&type=script&lang=ts&"
export * from "./TheorySignature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports